import React from "react";
import "./Choose.css";
import "twin.macro";
import Title from "../../Title";
import wave from "../../../icons/Wave.svg";
import { WhyChooseUsData } from "../../../data/WhyChooseUsData";
import Fade from "react-reveal/Fade";

const Choose = () => {
  return (
    <div
      style={{ backgroundImage: `url(${wave})` }}
      tw="bg-gray-700 bg-no-repeat bg-cover bg-center"
    >
      <div tw="flex  flex-col justify-center items-center  max-w-7xl mx-auto min-h-screen  p-5 py-40 md:py-5 space-y-10 ">
        <Title title="Why Choose us" />

        <div tw="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {WhyChooseUsData.map((card, index) => (
            <Fade>
              <div className="item" key={index}>
                {" "}
                <span className={`icon ${card.class}`}>
                  <i className={`fa ${card.icon}`}></i>
                </span>
                <h6 tw="text-xl">{card.title}</h6>
                <p>{card.content}</p>
              </div>
            </Fade>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Choose;
